import { API } from "../../api";
async function forgot_password(request) {
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `user/forgot_password`,
        content: request,
    });
}
export { forgot_password };
